import { SVF } from '../types/Siniestro/types';

export const getVetFormIdFromSVFs = (
  svfs: SVF[],
  siniestroId: number | string,
): number | null => {
  // Filtrar SVFs de este siniestro y obtener el más reciente (mayor vetFormId)
  const matching = svfs.filter((item) => String(item.siniestroId) === String(siniestroId));
  if (!matching.length) return null;

  // Ordenar por vetFormId descendente y tomar el primero (más reciente)
  const mostRecent = matching.sort((a, b) => b.vetFormId - a.vetFormId)[0];
  return mostRecent.vetFormId;
};
